import React, { useState } from "react";
import "../styles/LearnerDashboard.css";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Tutorials from "../components/Tutorials";
import home from "../images/home.png"; // Icons for sidebar
import feedback from "../images/feedback.png";
import tutorials from "../images/tutorials.png";
import history from "../images/history.png";

const TutorialsPage = () => {
  const [activeItem, setActiveItem] = useState("home");
  const [isVideoMode, setIsVideoMode] = useState(true);
  const [searchQuery, setSearchQuery] = useState(''); 

  const toggleMode = (mode) => {
    setIsVideoMode(mode);
  };

  const resetSearch = () => {
    setSearchQuery(""); // Reset the search query
  };

  const learnerMenuItems = [
    { icon: home, label: "Home", key: "home" },
    { icon: feedback, label: "Feedback", key: "feedback" },
    { icon: tutorials, label: "Tutorials", key: "tutorials", disabled: true},
    { icon: history, label: "History", key: "history", disabled: true },
  ];

  const getHeaderVisibility = () => {
    if (activeItem === "home" || activeItem === "") {
      return { showSearch: true, showToggle: true, showUserProfile: true };
    } else if (activeItem === "feedback") {
      return { showSearch: false, showToggle: false, showUserProfile: true };
    }
    return { showSearch: false, showToggle: false, showUserProfile: true };
  };

  const handleActiveItemChange = (item) => {
    setActiveItem(item); // Update active item
    resetSearch(); // Reset search whenever a new section is selected
  };

  const { showSearch, showToggle, showUserProfile } = getHeaderVisibility();

  return (
    <div className="dashboard">
      <Header
        isVideoMode={isVideoMode}
        toggleMode={toggleMode}
        showSearch={showSearch}
        showToggle={showToggle}
        showUserProfile={showUserProfile}
        searchQuery={searchQuery}
        onSearch={(query) => setSearchQuery(query)}
      />
      <main className="main-content">
        <Sidebar
          activeItem={activeItem}
          setActiveItem={handleActiveItemChange}
          menuItems={learnerMenuItems}
          resetSearch={resetSearch}
        />

        <div className="content">
        <Tutorials searchQuery={searchQuery} />;
        </div>
      </main>
    </div>
  );
};

export default TutorialsPage;
